import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ORingFailureRoutingModule } from './o-ring-failure-routing.module';
import { ORingFailureComponent } from './o-ring-failure.component';
import { CtaFullWidthModule } from 'src/app/shared/cta-full-width/cta-full-width.module';
import { RelatedLinksModule } from '../related-links/related-links.module';

@NgModule({
  declarations: [ORingFailureComponent],
  imports: [
    CommonModule,
    ORingFailureRoutingModule,
    CtaFullWidthModule,
    RelatedLinksModule
  ]
})
export class ORingFailureModule { }
